import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FilterOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"
import {
    GeometryFilterOperatorNode,
    filterOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"

export type PointGeometryFilterOperatorParameters = FilterOperatorParameters<PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryFilterOperatorParameters> = {
    nodeClass: "PointGeometryFilterOperator",
    validation: {
        parameters: filterOperatorParametersSchema(pointGeometryAttributeLike, pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryFilterOperator
    extends GeometryFilterOperatorNode<0, PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
